import { useAuth } from '@contexts/AuthContext';
import { useFamilyRegistrationStatus } from '@hooks/useFamilyRegistrationStatus';

/**
 * True when a signed-in parent still owes this year's family registration.
 */
export function usePendingFamilyRegistration(): {
  pendingFamilyRegistration: boolean;
  isLoading: boolean;
} {
  const { user, token } = useAuth();
  const { isComplete: familyRegComplete, isLoading: familyRegLoading } =
    useFamilyRegistrationStatus();

  const pendingFamilyRegistration =
    !familyRegLoading &&
    Boolean(token && user) &&
    !familyRegComplete &&
    !user?.familyRegistrationExempt &&
    user?.role === 'parent';

  return { pendingFamilyRegistration, isLoading: familyRegLoading };
}
